import { assignIfExists, assignProps } from '@/utils/resultsHelper';
import { responseError } from '@/utils/errors';
import { states } from '@/constants/lifecycle';
import { pruneRoleErrors } from '@/roles/state/state';
import withDraft from '@/utils/draftHelper';
import { findAllUserGroups, findUserGroup } from './state';
import { updateUsergroupActions } from '../constants';

const editUsergroup = withDraft((draft, action) => {
  const item = findUserGroup(draft, action);
  item.isEditing = true;
});

const editUsergroupCancel = withDraft((draft, action) => {
  const item = findUserGroup(draft, action);
  item.isEditing = false;
  item.saveStatus = states.NONE;
  item.saveErrors = [];
  item.isDirty = false;
});

const updateUsergroupProperties = withDraft((draft, action) => {
  const item = findUserGroup(draft, action);
  item.isEditing = true;
  assignIfExists(item, action.properties, undefined, true);
});

const updateUsergroup = withDraft((draft, action) => {
  const item = findUserGroup(draft, action);
  item.saveStatus = states.PENDING;
  item.saveErrors = [];
});

const updateUsergroupError = withDraft((draft, action) => {
  const item = findUserGroup(draft, action);
  item.saveStatus = states.ERROR;
  item.saveErrors = [responseError(action)];
});

const updateUsergroupSuccess = withDraft((draft, { category, code, result }) => {
  const item = findUserGroup(draft, { category, code });
  assignProps(item, {
    ...result,
    saveStatus: states.SUCCESS,
    saveErrors: [],
    copy: {
      ...result,
    },
    isEditing: false,
    isDirty: false,
  });

  findAllUserGroups(draft, { items: [{ code }] }).forEach((c) => {
    const userGroupInCategory = findUserGroup(draft, { category: c, code });
    if (userGroupInCategory) {
      assignProps(userGroupInCategory, { ...result });
    }
  });
});

const updateActiveUsergroupProperties = withDraft((draft, action) => {
  assignIfExists(draft.activeUserGroup, action.properties);
  draft.activeUserGroup.saveErrors = pruneRoleErrors(
    draft.activeUserGroup.saveErrors,
    action,
  );
});

export default {
  [updateUsergroupActions.EDIT_USERGROUP]: editUsergroup,
  [updateUsergroupActions.EDIT_USERGROUP_CANCEL]: editUsergroupCancel,
  [updateUsergroupActions.UPDATE_ACTIVE_USERGROUP_PROPERTIES]: updateActiveUsergroupProperties,
  [updateUsergroupActions.UPDATE_USERGROUP]: updateUsergroup,
  [updateUsergroupActions.UPDATE_USERGROUP_ERROR]: updateUsergroupError,
  [updateUsergroupActions.UPDATE_USERGROUP_PROPERTIES]: updateUsergroupProperties,
  [updateUsergroupActions.UPDATE_USERGROUP_SUCCESS]: updateUsergroupSuccess,
};
